import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { FacilityConsoleEquipmentsObject } from '../../core/services/facility.model';
import { FacilityService } from '../../core/services/facility.service';

interface IConsolePref {
  lastSelectedFacility: object | string;
  lastSelectedConsole: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConsoleService {
  private _consoleList = new Array<FacilityConsoleEquipmentsObject>();
  private _selectedConsole: string;
  private _selectedConsoleSource = new Subject<string>();
  public selectedConsoleSource = this._selectedConsoleSource.asObservable();

  constructor(private _facilityService: FacilityService,
    private _http: HttpClient, private _header: HttpHeadersService) {
  }

  get() {
    this._consoleList = [];
    let consoles: FacilityConsoleEquipmentsObject[] = [];
    this._facilityService.selectedMultiFacilities().forEach(element => {
      const fac = this._facilityService.getFacilityById(element);
      if(fac && fac.consoleEquipments) consoles = consoles.concat(...fac.consoleEquipments);
    });
    this._consoleList = consoles.filter((v, i, a) => a.findIndex(f => f.consoleType === v.consoleType) === i);
    return this._consoleList;
  }

  selectedConsole(): string {
    return this._selectedConsole;
  }

  selectedConsoleDistroy(): void {
    this._selectedConsole = '';
  }

  selectConsole(type: string, needToUpdate: boolean, redirectUrl?: string) {

    if (!this._selectedConsole) {
      this.get();
    }

    if (type != this._selectedConsole) {
      // check same
      let selectedConsoleInfo: FacilityConsoleEquipmentsObject | undefined;
      selectedConsoleInfo = this._consoleList.find(console => {
        return console.consoleType === type;
      });

      if (selectedConsoleInfo) {
        this._selectedConsole = selectedConsoleInfo.consoleType;
      }

      // check the selected console available on console list.
      if (!this._selectedConsole) {
        this._selectedConsole = this._consoleList[0].consoleType;
      }

      // update facility preference for current user
      if (needToUpdate || type !== this._selectedConsole) {
        if (!redirectUrl) {
          // tslint:disable-next-line: max-line-length
          this.updatedConsolePreferenceForUser({ lastSelectedFacility: this._facilityService.selectedFacilityId, lastSelectedConsole: this._selectedConsole });
        }
        else {
          // tslint:disable-next-line: max-line-length
          this.updatedConsolePreferenceForUser({ lastSelectedFacility: this._facilityService.selectedFacilityId, lastSelectedConsole: this._selectedConsole }, redirectUrl);
        }
      }

      // stream
      this._selectedConsoleSource.next(this._selectedConsole);

    }
  }

  updatedConsolePreferenceForUser(data: IConsolePref, url?: string) {
    const headers = this._header.bearerHttpAuthorizationHeader();
    this._http.post(`${environment.servicePath}/lfasset_facility/user_preference`, data, { headers }).subscribe(
      () => {
        if (url) {
          window.location.href = url;
        }
        // no need to do anything with success
      },
      () => {
        // need to set old facility id
      }
    );
  }
}
